import BaseProxy from './Proxy';

export default class ReservationConfirmationProxy extends BaseProxy {
  constructor(parameters = {}) {
    super('api/substore/reservationconfirmation', parameters);
  }

  find(subscriptionTemplateId) {
    return this.submit('get', `${this.endpoint}/${subscriptionTemplateId}`);
  }
}
